import {Check} from '@mui/icons-material'
import {Button} from '@mui/material'
import {useState} from 'react'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router'

import {useCreateAssetConfig} from '../../../../api/useCreateAssetConfig'
import {useUpdateAssetConfig} from '../../../../api/useUpdateAssetConfig'
import {getIsKilnConfigValid, kilnConfigToApiData} from '../../../../helpers'
import {useUrlParam} from '../../../../hooks'
import {useKilnConfig} from '../../../../providers'

import {SaveKilnDialog} from './SaveKilnDialog'

interface SaveKilnChangesTriggerProps {
  isConfigMissing: boolean
  bypassNavigationBlocker: () => void
}

export const SaveKilnChangesTrigger: React.FC<SaveKilnChangesTriggerProps> = ({
  isConfigMissing,
  bypassNavigationBlocker
}) => {
  const {t} = useTranslation()
  const navigate = useNavigate()

  const kilnId = useUrlParam('kilnId')
  const plantId = useUrlParam('plantCode')

  const {kilnLayout, kilnConfiguration} = useKilnConfig()
  const {isKilnConfigValid} = getIsKilnConfigValid(kilnLayout, kilnConfiguration)

  const [isSaveKilnDialogOpen, setIsSaveKilnDialogOpen] = useState(false)

  const {mutate: createAssetConfig, isPending: isCreateConfigPending} = useCreateAssetConfig()
  const {mutate: updateAssetConfig, isPending: isUpdateConfigPending} = useUpdateAssetConfig()

  const handleSubmit = () => {
    bypassNavigationBlocker()
    const mutateConfigFn = isConfigMissing ? createAssetConfig : updateAssetConfig
    mutateConfigFn(
      kilnConfigToApiData({
        kilnLayout,
        kilnConfiguration,
        plantId,
        assetId: kilnId
      }),
      {
        onSuccess: async () => {
          await navigate(-2)
        }
      }
    )
  }

  return (
    <>
      <Button
        variant="contained"
        startIcon={<Check />}
        onClick={() => setIsSaveKilnDialogOpen(true)}
        data-test-id="finish-setup-btn"
      >
        {t('kilnConfig.save')}
      </Button>
      <SaveKilnDialog
        open={isSaveKilnDialogOpen}
        loading={isCreateConfigPending || isUpdateConfigPending}
        isValid={isKilnConfigValid}
        onClose={() => setIsSaveKilnDialogOpen(false)}
        handleSubmit={handleSubmit}
      />
    </>
  )
}
